import { Breadcrumbs, Typography } from '@mui/joy';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { type Breadcrumb } from '@/types';

type Props = {
  items: Breadcrumb[];
  currentItem?: string;
  className?: string;
};

const BreadCrumb: React.FC<Props> = ({ items, currentItem, className }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumbs className={classNames('lowercase', className)} size="sm">
      {items.map((item) => (
        <Link key={item.name} to={item.route}>
          {t(item.name)}
        </Link>
      ))}
      {!!currentItem && <Typography>{currentItem}</Typography>}
    </Breadcrumbs>
  );
};

export default BreadCrumb;
